import { http } from '../http';

export const getCalendarData = async (contactId, date) => {
  try {
    const url = `users/${contactId}/calendar-events`;
    const response = await http.get(url, {
      params: { startDate: date?.startDate, endDate: date?.endDate },
      baseURL: process.env.BFFV2_BASE_URL,
    });

    if (!response?.status === 200) {
      throw new Error("Can't get companies");
    }
    return response?.data;
  } catch (e) {
    console.error('something went wrong', e);
    return false;
  }
};

export default {
  getCalendarData,
};
